"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@ellucian/react-design-system/core");
var _reactRedux = require("react-redux");
var _formSlice = require("../redux/slices/formSlice");
var _userenderscount = _interopRequireDefault(require("@hedtech/userenderscount"));
var _reactIntl = require("react-intl");
var _toolkit = require("@reduxjs/toolkit");
var _lodash = require("lodash");
var _excluded = ["intl"],
  _excluded2 = ["children", "formatFromStore", "formatToStore", "helperText", "name", "label", "onBlur", "onFocus", "onChange", "required", "requiredErrorTextId", "validate"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var FormDropdownTypeahead = function FormDropdownTypeahead(_ref) {
  var intl = _ref.intl,
    props = _objectWithoutProperties(_ref, _excluded);
  var children = props.children,
    _props$formatFromStor = props.formatFromStore,
    formatFromStore = _props$formatFromStor === void 0 ? _lodash.identity : _props$formatFromStor,
    _props$formatToStore = props.formatToStore,
    formatToStore = _props$formatToStore === void 0 ? _lodash.identity : _props$formatToStore,
    _props$helperText = props.helperText,
    helperTextProp = _props$helperText === void 0 ? null : _props$helperText,
    nameProp = props.name,
    label = props.label,
    onBlurProp = props.onBlur,
    onFocusProp = props.onFocus,
    onChangeProp = props.onChange,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$requiredErrorT = props.requiredErrorTextId,
    requiredErrorTextId = _props$requiredErrorT === void 0 ? 'validateRequired' : _props$requiredErrorT,
    validateProp = props.validate,
    rest = _objectWithoutProperties(props, _excluded2);
  (0, _userenderscount["default"])("FormDropdownTypeahead( ".concat(nameProp, " )"));
  var formatMessage = intl.formatMessage;
  var dispatch = (0, _reactRedux.useDispatch)();
  var selectAlwaysShowError = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.meta, "forceShowErrors.".concat((0, _lodash.head)((0, _lodash.toPath)(nameProp))));
    }, function (value) {
      return !!value;
    });
  }, [nameProp]);
  var selectValue = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.values, (0, _lodash.toPath)(nameProp));
    }, function (value) {
      return value ? formatFromStore(value) : '';
    });
  }, [nameProp, formatFromStore]);
  var selectError = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.errors, (0, _lodash.toPath)(nameProp));
    }, _lodash.identity);
  }, [nameProp]);
  var selectTouched = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.touched, (0, _lodash.toPath)(nameProp));
    }, _lodash.identity);
  }, [nameProp]);
  var value = (0, _reactRedux.useSelector)(selectValue);
  var error = (0, _reactRedux.useSelector)(selectError);
  var touched = (0, _reactRedux.useSelector)(selectTouched);
  var alwaysShowError = (0, _reactRedux.useSelector)(selectAlwaysShowError);
  var validate = (0, _react.useMemo)(function () {
    var isRequired = function isRequired(value) {
      if (!required) {
        return undefined;
      }
      if (!value) {
        return formatMessage({
          id: requiredErrorTextId
        });
      }
    };
    var composeValidators = function composeValidators() {
      var fns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return function (value, allValues, meta) {
        var validators = [isRequired].concat(_toConsumableArray(fns));
        var error;
        for (var x = 0; x < validators.length; x++) {
          error = validators[x](value, allValues, meta);
          if (error) {
            break;
          }
        }
        return error;
      };
    };
    var validatorsArray = validateProp;
    if (validateProp && typeof validateProp === 'function') {
      validatorsArray = [validateProp];
    }
    return composeValidators(validatorsArray);
  }, [formatMessage, required, validateProp, requiredErrorTextId]);
  (0, _react.useEffect)(function () {
    dispatch((0, _formSlice.validateField)({
      name: nameProp,
      validate: validate,
      value: value
    }));
  }, [dispatch, nameProp, validate, value]);
  var onChange = (0, _react.useCallback)(function (value) {
    dispatch((0, _formSlice.setValue)({
      name: nameProp,
      value: formatToStore(value)
    }));
    onChangeProp && onChangeProp(value);
  }, [dispatch, formatToStore, nameProp, onChangeProp]);
  var onBlur = (0, _react.useCallback)(function (e) {
    (0, _reactRedux.batch)(function () {
      dispatch((0, _formSlice.setTouched)({
        name: nameProp,
        value: true
      }));
      dispatch((0, _formSlice.setFocused)({
        name: nameProp,
        value: false
      }));
    });
    onBlurProp && onBlurProp(e);
  }, [dispatch, onBlurProp, nameProp]);
  var onFocus = (0, _react.useCallback)(function (e) {
    dispatch((0, _formSlice.setFocused)({
      name: nameProp,
      value: true
    }));
    onFocusProp && onFocusProp(e);
  }, [dispatch, onFocusProp, nameProp]);
  var hasError = false;
  var helperText = helperTextProp;
  if (error && (touched || alwaysShowError)) {
    hasError = true;
    helperText = error;
  }
  return /*#__PURE__*/_react["default"].createElement(_core.DropdownTypeahead, _extends({}, rest, {
    error: hasError,
    helperText: helperText,
    name: nameProp,
    label: label,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    required: required,
    inputProps: {
      'aria-required': required,
      'role': 'combobox',
      'aria-autocomplete': 'list',
      'aria-haspopup': 'listbox',
      'aria-label': "Dropdown menu for ".concat(label, ", start typing to search and use arrow keys to navigate")
    },
    value: value
  }), children);
};
FormDropdownTypeahead.propTypes = {
  intl: _propTypes["default"].object,
  children: _propTypes["default"].node,
  formatFromStore: _propTypes["default"].func,
  formatToStore: _propTypes["default"].func,
  helperText: _propTypes["default"].node,
  name: _propTypes["default"].string.isRequired,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  requiredErrorTextId: _propTypes["default"].string,
  label: _propTypes["default"].string,
  validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)])
};
var _default = exports["default"] = (0, _reactIntl.injectIntl)(FormDropdownTypeahead);